import { Icon } from "../../icons";
import { useTranslation } from "../../localization";

export function FileExplorerDropIndicator() {
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="inset-0 absolute z-[1] flex-center bg-accent-500/20 flex flex-col gap-4">
			<Icon
				name="Files"
				size={32}
				strokeWidth={2}
				className="stroke-accent-500"
			/>
			<p className="text-sm">{t("files.drop_files_here")}</p>
		</div>
	);
}
